import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpService, GET, Adapter } from "@royalty/httpclient";

@Injectable()
export class SysService extends HttpService {
	/**
	 * System services
	 */
	@GET("sys/about")
	@Adapter(null, { isAdmin: false })
	serverInfo(): Observable<any> {
		return null;
	}
}
